import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {UserSummaryConverter} from '../../../../../account/modules/user/api/converter/userSummary.converter';
import {ProductRetrocessionRuleModel} from '../productRetrocessionRule.model';

@Injectable()
export class ProductRetrocessionRuleConverter extends HttpModelConverter<ProductRetrocessionRuleModel> {

    constructor() {
        super();
    }

    protected createInstance(): ProductRetrocessionRuleModel {
        return new ProductRetrocessionRuleModel();
    }

    protected enrichObject(result: ProductRetrocessionRuleModel, src: ProductRetrocessionRuleModel) {
        result.from = new UserSummaryConverter().convert(src.from);
        result.to = new UserSummaryConverter().convert(src.to);
    }
}
